import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col } from "reactstrap";
import Ink from "react-ink";
import base64 from "base-64";
import api from "../../config/api";
import { BlobProvider } from "@react-pdf/renderer";

import ConsentFormModal from "../../component/ConsentFormModal";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import ConsentFormPDF from "../../component/ConsentFormPDF";
import {
  imageToDataURL,
  isNetworkRequestFailedError,
} from "../../config/helpers";
import historyAction from "../../redux/history/action";
import authAction from "../../redux/auth/action";
import mpAction from "../../redux/microPensionDublicated/action";
import InputComp from "../../component/InputComp/InputComp";
import CustomButton from "../../component/CustomButton/CustomButton";

class Picture extends Component {
  state = {
    pictureImageError: "",
    isLoading: false,
  };

  componentDidMount() {
    const { customRef } = this.props;

    customRef({ validate: this.validate });
  }

  handleOnChange = async (e) => {
    const { setPictureField, setAlertMessage } = this.props;

    try {
      if (e.target.files[0]) {
        const response = await imageToDataURL(e.target.files[0]);

        setPictureField(response);
        this.openModal();
      }
    } catch (error) {
      setAlertMessage({
        type: "error",
        message: error.message,
        onTryAgain: isNetworkRequestFailedError(error)
          ? () => this.handleOnChange(e)
          : null,
      });
    }
  };

  openModal = () => {
    this.props.setConsentFormField("");
    this.setState({ isModal: true });
  };

  validate = () => {
    const { pictureImage, formImage } = this.props;
    let error = "";

    if (!pictureImage) {
      error = "Picture is required";
    } else if (!formImage) {
      error = "Please accept consent form";
    }

    return error;
  };

  upload = async () => {
    const {
      personalDetail,
      employer,
      nextOfKin,
      residence,
      pictureImage,
      formImage,
      signatureImage,
      bankDetails,
      validateUser,
      setAlertMessage,
      resetRSAForm,
    } = this.props;

    const header = {
      Authorization:
        "Basic " +
        base64.encode(validateUser.userName + ":" + validateUser.password),
    };

    try {
      if (this.validate()) {
        throw new Error(this.validate());
      }

      this.setState({ isLoading: true });

      const data = {
        ...personalDetail,
        ...employer,
        ...nextOfKin,
        ...residence,
        ...bankDetails,
        pictureImage: pictureImage ? pictureImage.split("base64,")[1] : "",
        formImage: formImage ? formImage.split("base64,")[1] : "",
        signatureImage: signatureImage
          ? signatureImage.split("base64,")[1]
          : "",
        agentCode: "MPPPPL",
      };
      data.employerRcno = employer.employerRawCode;
      delete data.employerRawCode;
      delete data.employerCode;
      // console.log("data =>", data);

      // delete data.firstName;
      delete data.middleName;
      // delete data.maidenOrFormerName;
      // delete data.employerStateCode
      // delete data.dateOfFirstAppointment
      delete data.nokMiddleName;
      delete data.nokResidenceStateCode;

      // delete data.picture
      // delete data.consentForm
      // delete data.signature

      delete data.residenceHouseNo;
      delete data.employerStreetName;
      delete data.employerBuildingNameOrNumber;
      delete data.nokResidenceHouseNumber;

      const response = await api.RSAPinSubmit(data, header);
      setAlertMessage({ type: "success", message: response.errorMessage });
      resetRSAForm();
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.upload : null,
      });
    }

    this.setState({ isLoading: false });
  };

  getName = () => {
    const { personalDetail } = this.props;

    return {
      firstName: personalDetail.firstname,
      middleName: personalDetail.middleName,
      lastName: personalDetail.surname,
    };
  };

  handleSubmit = () => {
    this.setState({ submit: true });
  };

  getDataForPDF = () => {
    const { personalDetail, signatureImage } = this.props;

    return {
      name: {
        firstName: personalDetail.firstname,
        middleName: personalDetail.middleName,
        lastName: personalDetail.surname,
      },
      signature: signatureImage,
    };
  };

  render() {
    const { pictureImage } = this.props;
    const { pictureImageError, isLoading, isModal } = this.state;

    return (
      <div>
        <input
          onChange={this.handleOnChange}
          style={{ display: "none" }}
          type="file"
          id="pictureImage"
        />
        <Row className="flex1">
          <Col lg={9} md={9} sm={6} className="p-0">
            <InputComp
              disabled={true}
              errorMessage={pictureImageError}
              type="text"
              placeholder="Picture"
              containerStyles={{ width: "100%" }}
            />
          </Col>
          <Col lg={3} md={3} sm={6} className="mx-auto pl-0 pl-sm-3 pr-0">
            <label className="browser-btn-container" htmlFor="pictureImage">
              <span className="btn browse-btn">
                Browse
                <Ink />
              </span>
            </label>
          </Col>
        </Row>
        {!!pictureImage && (
          <div className="text-center my-2">
            <img alt="" width="300px" src={pictureImage} />
          </div>
        )}
        <div className="text-center my-2">
          <Row className="my-2 justify-content-center">
            {this.props.pictureImage && !this.props.formImage && (
              <Col className="p-0 pr-2" sm={6} md={3}>
                <CustomButton
                  buttonClasses="btn-block"
                  buttonText="Accept Consent Form"
                  onClick={() => {
                    this.setState({ isModal: true });
                  }}
                />
              </Col>
            )}
            <Col className="p-0" sm={6} md={3}>
              <CustomButton
                buttonClasses="btn-block"
                buttonText="Upload"
                onClick={() => {
                  this.upload();
                }}
              />
            </Col>
          </Row>
        </div>
        {isLoading && <CustomLoader />}
        <ConsentFormModal
          signature={this.props.signatureImage}
          onSubmit={this.handleSubmit}
          name={this.getName()}
          onClose={() => this.setState({ isModal: false })}
          isOpen={isModal}
        />
        {this.state.submit && (
          <BlobProvider
            document={<ConsentFormPDF data={this.getDataForPDF()} />}
          >
            {({ blob, url, loading, error }) => {
              if (!loading && !this.state.blob) {
                const reader = new FileReader();

                reader.readAsDataURL(blob);
                reader.onloadend = () => {
                  const base64data = reader.result;

                  this.props.setConsentFormField(base64data);
                  this.setState({ submit: false });
                };

                this.setState({ blob });
              }

              return null;
            }}
          </BlobProvider>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  personalDetail: state.microPensionDublicated.personalDetail,
  pictureImage: state.microPensionDublicated.pictureImage,
  residence: state.microPensionDublicated.residence,
  employer: state.microPensionDublicated.employer,
  nextOfKin: state.microPensionDublicated.nextOfKin,
  signatureImage: state.microPensionDublicated.signatureImage,
  formImage: state.microPensionDublicated.formImage,
  bankDetails: state.microPensionDublicated.bankDetails,
  validateUser: state.onboarding.user,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setPictureField: mpAction.setPictureField,
  setAlertMessage: authAction.setAlertMessage,
  setConsentFormField: mpAction.setConsentFormField,
  resetRSAForm: mpAction.resetRSAForm,
};

export default connect(mapStateToProps, mapDispatchToProps)(Picture);
